import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FreightsData } from "../../../../core/models/bcLedger/freightsResponseDto";
import { GetSalesOrderIdRequestDto } from "../../../../core/models/bcLedger/getSalesOrderIdRequestDto";
import { GetSalesOrderIdData } from "../../../../core/models/bcLedger/getSalesOrderIdResponseDto";
import { MoveToFreightRequestDto } from "../../../../core/models/bcLedger/moveToFreightRequestDto";
import { MoveToFreightResponseDto } from "../../../../core/models/bcLedger/moveToFreightResponseDto";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { CommonModule } from "@angular/common";
import { DrawerModule } from "primeng/drawer";
import { FormsModule } from "@angular/forms";
import { BcledgerService } from "../../../../core/services/bcledger.service";
import { SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { DatePickerModule } from "primeng/datepicker";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-move-to-freight",
  templateUrl: "./move-to-freight.component.html",
  styleUrls: ["./move-to-freight.component.scss"],
  imports: [
    CommonModule,
    SelectModule,
    DrawerModule,
    FormsModule,
    ButtonModule,
    DatePickerModule,
    InputTextModule,
  ],
})
export class MoveToFreightComponent implements OnInit {
  @Input() display!: boolean;
  @Input() brandingConsultantID!: string;
  @Input() freightSelected!: FreightsData;
  @Output() displayChange = new EventEmitter<boolean>();
  @Output() moveToFreightEvent = new EventEmitter<boolean>();
  salesOrderIdList: GetSalesOrderIdData[] = [];
  salesOrderSelected!: string;
  moveToFreightForm: MoveToFreightRequestDto = {} as MoveToFreightRequestDto;
  moveToFreightResponse: MoveToFreightResponseDto =
    {} as MoveToFreightResponseDto;
  postingDate: Date = new Date();

  constructor(
    private _moveToFreightService: BcledgerService,
    private _toastrService: JniToastrService,
    private _loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.getSalesOrderID({ BrandingConsultantID: this.brandingConsultantID });
  }

  getSalesOrderID(payload: GetSalesOrderIdRequestDto) {
    this._moveToFreightService.getSalesOrderID(payload).subscribe({
      next: res => {
        if (res.data) {
          this.salesOrderIdList = res.data.Data ?? [];
          return;
        }
        this._toastrService.error(
          res.message ?? "Sales Order Id Fetched",
          "Sales Order Id"
        );
      },
      error: () => {
        this._toastrService.error(
          "Sales Order Id Not Fetched",
          "Sales Order Id"
        );
      },
    });
  }

  moveToFreight(payload: MoveToFreightRequestDto) {
    this._loaderService.setLoaderState(true);
    this._moveToFreightService.moveToFreight(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.moveToFreightResponse = res.data;
          this._toastrService.success(
            res.message ?? "Move To Freight Fetched",
            "Move To Freight"
          );
          this.moveToFreightEvent.emit(true);
          return;
        }
        this._toastrService.error(res.message ?? "No results found", "Error");
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastrService.error("No results found", "Error");
      },
    });
  }

  onHide() {
    this.displayChange.emit(false);
  }

  onFromDateSelection(event: Event) {
    const target = event.target as HTMLInputElement;
    this.moveToFreightForm.PostingDate = target?.value;
  }

  onSubmit() {
    this.moveToFreightForm.BrandingConsultantID = this.brandingConsultantID;
    this.moveToFreightForm.RecID =
      this.freightSelected?.RecID?.toString() ?? "";
    this.moveToFreightForm.SalesID = this.salesOrderSelected;
    this.moveToFreightForm.PostingDate =
      this.moveToFreightForm.PostingDate ??
      this.postingDate.toLocaleDateString();

    this.moveToFreight(this.moveToFreightForm);
  }

  onSalesOrderSelectionClear() {
    this.salesOrderSelected = "";
  }
}
